var map = {
	"./bedford/Privacy": 55307,
	"./broxbourne/Privacy": 62841,
	"./darlington/Privacy": 56467,
	"./defaults/Privacy": 26861,
	"./demo/Privacy": 86720,
	"./hull/Privacy": 49444,
	"./kirklees/Privacy": 46079,
	"./leicester/Privacy": 25971,
	"./northgate/Privacy": 61093,
	"./preston/Privacy": 17858,
	"./rushcliffe/Privacy": 49424,
	"./slough/Privacy": 25791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21087;